// msalConfig.js
import { PublicClientApplication, LogLevel } from "@azure/msal-browser";

const pca = new PublicClientApplication({
	auth: {
		clientId: "b4bde5d2-9156-4ac8-a778-e6a4ca7e0851",
		authority:
			"https://login.microsoftonline.com/46c5178e-a0f4-4f4d-8c40-9598e3d11860/v2.0",

		redirectUri: "https://etp-techdev.cushwake.com",
	},
	cache: {
		cacheLocation: "localStorage",
		storeAuthStateInCookie: false,
	},
	system: {
		loggerOptions: {
			loggerCallback: (logLevel, message, containsPii) => {
				// Ensure logs are only generated for errors or warnings
				if (logLevel === LogLevel.Error || logLevel === LogLevel.Warning) {
					console.error(message); // Logs only critical issues
				}
			},
			logLevel: LogLevel.Error, // Restrict logs to errors only
			piiLoggingEnabled: false, // Disable logging of personally identifiable information
		},
	},
});

// Define and export loginRequest with the required scopes
export const loginRequest = {
	scopes: [
		"User.Read", // ✅ Required for user profile
	],
};

export default pca;
